import { connect } from 'react-redux'
import { func, string } from 'prop-types'
import { Link } from 'redux-little-router'
import { buildClearAllHref } from '../../../selectors'
import { clearAllWasClicked } from '../../../actions/filter'
import React from 'react'

class ClearAll extends React.PureComponent {
  handleClick = () => {
    this.props.clearAllWasClicked()
  }
  render() {
    if (this.props.clearAllHref === null) {
      return null
    }
    return (
      <div className="clear-all">
        <Link
          href={this.props.clearAllHref}
          onClick={this.handleClick}
          replaceState
        >
          Clear all
        </Link>
      </div>
    )
  }
}
ClearAll.defaultProps = {
  clearAllHref: null,
}
ClearAll.propTypes = {
  clearAllHref: string,
  clearAllWasClicked: func.isRequired,
}

const mapStateToProps = state => ({
  clearAllHref: buildClearAllHref(state),
})

export default connect(mapStateToProps, {
  clearAllWasClicked,
})(ClearAll)
